import { FormForType, formFor, Validators } from "fw-model";
import { MarketingEmailTemplate } from "models/marketing-email-template";
import { noNewLines } from "./validators";

const { isEmail, wrap } = Validators;

export type FormForMarketingEmailTemplate = FormForType<MarketingEmailTemplate>;

export class CreateMarketingEmailTemplateAction {
  public created: MarketingEmailTemplate = null;
  constructor(public form: FormForMarketingEmailTemplate) {}
}

export class UpdateMarketingEmailTemplateAction {
  public updated: MarketingEmailTemplate = null;
  constructor(public form: FormForMarketingEmailTemplate) {}
}

export class DeleteMarketingEmailTemplateAction {
  constructor(public ids: number | number[], public all?: boolean, public toggle?: boolean, public search?: string) {}
}

export class CopyMarketingEmailTemplateAction {
  constructor(public ids: number | number[], public all?: boolean, public toggle?: boolean, public search?: string) {}
}

export class ActivateMarketingEmailTemplateAction {
  constructor(public ids: number | number[], public all?: boolean, public toggle?: boolean, public search?: string) {}
}

export class DeactivateMarketingEmailTemplateAction {
  constructor(public ids: number | number[], public all?: boolean, public toggle?: boolean, public search?: string) {}
}

export const createMarketingEmailTemplateFormCreator = formFor(MarketingEmailTemplate, s => {
  s.requiredField(et => et.Name, "Name");
  s.field(et => et.Subject, "Subject", wrap(noNewLines));
  s.field(et => et.FromName, "From name");
  s.field(et => et.FromAddress, "From address", wrap(isEmail));
  s.field(et => et.ReplyToName, "Reply to name");
  s.field(et => et.ReplyToAddress, "Reply to address", wrap(isEmail));
  s.field(et => et.Alignment, "Alignment");
  s.requiredField(et => et.EmailTemplateDesignId, "Design");
  s.requiredField(et => et.ContentType, "Content type");
  s.field(et => et.Html, "Html content");
  s.field(et => et.Text, "Text content");
  s.field(et => et.Markup, "Markup content");
});

export const updateMarketingEmailTemplateFormCreator = formFor(MarketingEmailTemplate, s => {
  s.requiredField(et => et.Id, "Id");
  s.requiredField(et => et.Name, "Name");
  s.field(et => et.Subject, "Subject", wrap(noNewLines));
  s.field(et => et.FromName, "From name");
  s.field(et => et.FromAddress, "From address", wrap(isEmail));
  s.field(et => et.ReplyToName, "Reply to name");
  s.field(et => et.ReplyToAddress, "Reply to address", wrap(isEmail));
  s.field(et => et.Alignment, "Alignment");
  s.requiredField(et => et.EmailTemplateDesignId, "Design");
  s.requiredField(et => et.ContentType, "Content type");
  s.field(et => et.Html, "Html content");
  s.field(et => et.Text, "Text content");
  s.field(et => et.Markup, "Markup content");
});
